import { Element } from "@xmpp/xml"
import { GpsConfig } from "@/reducers/gpsConfigSlice"
import { GPS_CONFIG_NODE } from "@/api/xeps/GpsConfig"
import GpsConfigParser from "@/lib/gpsConfigParser"

type GpsConfigPubSubEvent = {
  type: "create" | "retract"
  gpsConfig: GpsConfig | { driverJid: string }
}

export default class GpsConfigPubSubEventParser {
  static parse = (stanza: Element): GpsConfigPubSubEvent | undefined => {
    const node = stanza
      .getChild("event")
      ?.getChildByAttr("node", GPS_CONFIG_NODE)

    if (!node) return

    if (node.getChild("item")) {
      return {
        type: "create",
        gpsConfig: GpsConfigParser.parseItem(node.getChild("item")!),
      }
    } else if (node.getChild("retract")) {
      return {
        type: "retract",
        gpsConfig: { driverJid: node.getChild("retract")?.getAttr("id") },
      }
    }
  }
}
